import React from 'react';

export function EmojiEventIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M38 10h-4V6H14v4h-4c-2.2 0-4 1.8-4 4v2c0 5.1 3.84 9.26 8.78 9.88 1.26 3 3.96 5.26 7.22 5.92V38h-8v4h20v-4h-8v-6.2c3.26-.66 5.96-2.92 7.22-5.92C38.16 25.26 42 21.1 42 16v-2c0-2.2-1.8-4-4-4zm-28 6v-2h4v7.64c-2.32-.84-4-3.04-4-5.64zm14 12c-3.3 0-6-2.7-6-6V10h12v12c0 3.3-2.7 6-6 6zm14-12c0 2.6-1.68 4.8-4 5.64V14h4v2z" />
    </svg>
  );
}
